import Button from 'react-bootstrap/Button';
import React, { Children } from 'react'
import { useState, useEffect } from 'react'
import {useParams} from 'react-router-dom';
import LogoImg from './logo.png';
import {findOne} from '../sevices/memid.mjs'
import { MDBCol, MDBContainer, MDBRow, MDBCard, MDBCardText, MDBCardBody, MDBCardImage, MDBTypography, MDBIcon } from 'mdb-react-ui-kit';



function MemberProfile() {
    const {id} = useParams();

    let showId = false;
   
if(id>=20200000&&id<=20200040){

  showId = true;
}
else{
  showId = false;
};
    let uName = 'IoT Club VNR VJIET';
    let pYear = 'Updating..';
    let rollNum = 'Updating..'
    let deptName = 'Electroincs and Communication';
    let dateJoin = "Updating..";
    let imgUrl = "./logo.png";

 
    let yosText = "Year of Studing:";

    const [loading, setLoading] = useState(false)
    const [countries, setCountries] = useState([])

    const fetchData = async () => {
        setLoading(true)

        const res = await findOne(id)
        
        setCountries(res)
        
        
        setLoading(false)
    }

    useEffect(() => {
        fetchData()
    }, [])

    //console.log(countries.name);
    if( countries != 0 ){
      console.log(countries.name);
    uName = countries.name;
    rollNum = countries.rollNum;
    deptName = countries.branch;
    pYear = countries.year;
    imgUrl = countries.img;
    dateJoin = countries.doj;
    
    if(imgUrl === ""){
        imgUrl=LogoImg;
    }
  }
  else{
    imgUrl=LogoImg;
  }
    if(id == 20200001){

        yosText = "Role:";
    }
  

  
    return (
      <div>
       <div style={{display: !showId ? 'block' : 'none'}}>

      
        <section  style={{ backgroundColor: '#f4f5f7' }}>
          <MDBContainer className="h-100" style={{marginTop: 10}}>
            <MDBRow className="justify-content-center align-items-center h-100">
              <MDBCol lg="6" className="mb-4 mb-lg-0">
                <MDBCard className="mb-3" style={{ borderRadius: '.5rem' }}>
                  <MDBRow className="g-0">
                    <MDBCol md="4" className="gradient-custom text-center text-white"
                      style={{ borderTopLeftRadius: '.5rem' , borderBottomLeftRadius: '.5rem' }}>
                      <MDBCardImage src={imgUrl}
                        alt="Avatar"  style={{ width: '100px', marginTop: 20 ,borderRadius:100 }} fluid />
                      
                      <MDBTypography className="name-font" tag="h5" style={{marginTop: 15}}> {uName}</MDBTypography>
                      <MDBCardText style={{marginTop: 15}}>{deptName}</MDBCardText>
                      <MDBIcon far icon="edit mb-5" />
                    </MDBCol>
                    <MDBCol md="8">
                      <MDBCardBody className="p-4">
                        <MDBTypography tag="h6">Membership Details</MDBTypography>
                        <hr className="mt-0 mb-4" />
                        <MDBRow className="pt-1">
                          <MDBCol size="6" className="mb-3">
                            <MDBTypography tag="h6">Membership Id:</MDBTypography>
                            <MDBTypography tag="h6">Date of Joining:</MDBTypography>
                            
                          </MDBCol>
                          <MDBCol size="6" className="mb-3">
                          <MDBCardText tag="h6" className="id-v-font">{id}</MDBCardText>
                            <MDBCardText tag="h6" className="id-v-font">{dateJoin}</MDBCardText>
                          </MDBCol>
                        </MDBRow>
    
                        <MDBTypography tag="h6">About</MDBTypography>
                        <hr className="mt-0 mb-4" />
                        <MDBRow className="pt-1">
                          <MDBCol size="6" className="mb-3">
                            <MDBTypography tag="h6">Roll Number:</MDBTypography>
                            <MDBTypography tag="h6">{yosText}</MDBTypography>
                            
                          </MDBCol>
                          <MDBCol size="6" className="mb-3">
                            
                            <MDBCardText  tag="h6" className="id-v-font">{rollNum}</MDBCardText>
                            <MDBCardText tag="h6" className="id-v-font">{pYear}</MDBCardText>
                          </MDBCol>
                        </MDBRow>
    
                        <div className="d-flex justify-content-start">
                          <a href="#!"><MDBIcon fab icon="facebook me-3" size="lg" /></a>
                          <a href="#!"><MDBIcon fab icon="twitter me-3" size="lg" /></a>
                          <a href="#!"><MDBIcon fab icon="instagram me-3" size="lg" /></a>
                        </div>
                      </MDBCardBody>
                    </MDBCol>
                  </MDBRow>
                </MDBCard>
              </MDBCol>
            </MDBRow>
          </MDBContainer>
        </section>
        </div>
        < div style={{display: showId ? 'block' : 'none'}} >

 

<section  style={{ backgroundColor: '#f4f5f7' }}>
<MDBContainer className="h-100" style={{marginTop: 10}}>
  <MDBRow className="justify-content-center align-items-center h-100">
    <MDBCol lg="6" className="mb-4 mb-lg-0">
      <MDBCard className="mb-3" style={{ borderRadius: '.5rem' }}>
        <MDBRow className="g-0">
          <MDBCol md="4" className="gradient-customcore text-center text-white"
            style={{ borderTopLeftRadius: '.5rem' , borderBottomLeftRadius: '.5rem' }}>
            <MDBCardImage src={imgUrl}
              alt="Avatar"  style={{ width: '100px', marginTop: 20 ,borderRadius:100 }} fluid />
            
            <MDBTypography className="name-font" tag="h5" style={{marginTop: 15,color:'#000000'}}> {uName}</MDBTypography>
            <MDBCardText style={{marginTop: 15,color:'#000000'}}>{deptName}</MDBCardText>
            <MDBIcon far icon="edit mb-5" />
          </MDBCol>
          <MDBCol md="8">
            <MDBCardBody className="p-4">
              <MDBTypography tag="h6">Membership 1 Details</MDBTypography>
              <hr className="mt-0 mb-4" />
              <MDBRow className="pt-1">
                <MDBCol size="6" className="mb-3">
                  <MDBTypography tag="h6">Membership Id:</MDBTypography>
                  <MDBTypography tag="h6">Date of Joining:</MDBTypography>
                  
                </MDBCol>
                <MDBCol size="6" className="mb-3">
                <MDBCardText tag="h6" className="id-v-font">{id}</MDBCardText>
                  <MDBCardText tag="h6" className="id-v-font">{dateJoin}</MDBCardText>
                </MDBCol>
              </MDBRow>

              <MDBTypography tag="h6">About</MDBTypography>
              <hr className="mt-0 mb-4" />
              <MDBRow className="pt-1">
                <MDBCol size="6" className="mb-3">
                  <MDBTypography tag="h6">Roll Number:</MDBTypography>
                  <MDBTypography tag="h6">{yosText}</MDBTypography>
                  
                </MDBCol>
                <MDBCol size="6" className="mb-3">
                  
                  <MDBCardText  tag="h6" className="id-v-font">{rollNum}</MDBCardText>
                  <MDBCardText tag="h6" className="id-v-font">{pYear}</MDBCardText>
                </MDBCol>
              </MDBRow>

              <div className="d-flex justify-content-start">
                <a href="#!"><MDBIcon fab icon="facebook me-3" size="lg" /></a>
                <a href="#!"><MDBIcon fab icon="twitter me-3" size="lg" /></a>
                <a href="#!"><MDBIcon fab icon="instagram me-3" size="lg" /></a>
              </div>
            </MDBCardBody>
          </MDBCol>
        </MDBRow>
      </MDBCard>
    </MDBCol>
  </MDBRow>
</MDBContainer>
</section>
</div>
</div>

      );
}

export default MemberProfile